import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("グループID")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_dialog = _resolveComponent("cus-dialog")
  const _component_KaishaGroup = _resolveComponent("KaishaGroup")
  const _component_select_dialog = _resolveComponent("select-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_cus_dialog, {
      title: _ctx.title,
      operation: _ctx.operation,
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clearForm())),
      onOperate: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCreateOrUpdate())),
      processing: _ctx.loading,
      width: "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          size: "small",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            (_ctx.operation === _ctx.DialogGenre.Edit)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "アカウントID",
                  prop: "accountId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.accountId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.accountId = $event)),
                      maxlength: "6",
                      disabled: true
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "グループID",
              prop: "groupId",
              class: "xl-input"
            }, {
              label: _withCtx(() => [
                _createVNode(_component_el_link, {
                  icon: "el-icon-edit-outline",
                  onClick: _withModifiers(_ctx.handleSelect, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.groupId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.groupId = $event)),
                  disabled: ""
                }, {
                  append: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.groupNm), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "会社コード",
              prop: "kaishaCd",
              class: "xl-input"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.kaishaCd,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.kaishaCd = $event)),
                  disabled: ""
                }, {
                  append: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.kaishaNm), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "個人コード",
              prop: "kjnCd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.kjnCd,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.kjnCd = $event)),
                  maxlength: "6"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "個人名",
              prop: "kjnNm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.kjnNm,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.kjnNm = $event)),
                  maxlength: "25"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "部署名",
              prop: "bushoNm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.bushoNm,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.bushoNm = $event)),
                  maxlength: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "メールアドレス",
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.email = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "権限",
              prop: "kengenCd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.kengenCd,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.kengenCd = $event)),
                  "popper-class": "shinseisha-kengen"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kengenOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.kengen_kubun,
                        value: item.kengen_kubun_cd
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "operation", "modelValue", "processing"]),
    _createVNode(_component_select_dialog, {
      title: "会社グループ選択",
      onCancel: _ctx.handleCloseDialog,
      modelValue: _ctx.selectDialogVisible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectDialogVisible = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_KaishaGroup, {
          isDialogMode: true,
          onSelect: _ctx.handleSelectInfo
        }, null, 8, ["onSelect"])
      ]),
      _: 1
    }, 8, ["onCancel", "modelValue"])
  ]))
}